import ReactDropdown from 'rc-dropdown'
import AvatarImg from '@/shared/assets/images/AvatarOem.png'
import { Logout } from '../logout'

export const HeaderDropdown = () => {
    return (
        <ReactDropdown
            overlay={(
                <div className='list-none bg-white border-color-dark [&>li:not(:last-child)]:border-b [&>li:not(:last-child)]:border-color-dark border rounded-xl overflow-hidden'>
                    <Logout />
                </div>
            )}
            trigger={['click']}
        >
            <button className='h-[60px] w-[60px]'>
                <img src={AvatarImg} className='h-full w-full object-contain' />
            </button>
        </ReactDropdown>
    )
}